import { render, staticRenderFns } from "./password-reset-done.vue?vue&type=template&id=3402efa6"
import script from "./password-reset-done.vue?vue&type=script&lang=js"
export * from "./password-reset-done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports